import { render, staticRenderFns } from "./listMenu.vue?vue&type=template&id=4cdcd667&scoped=true"
import script from "./listMenu.vue?vue&type=script&lang=js"
export * from "./listMenu.vue?vue&type=script&lang=js"
import style0 from "./listMenu.vue?vue&type=style&index=0&id=4cdcd667&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcd667",
  null
  
)

export default component.exports